import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2MailVerificationGiftDialogProperties extends BasicDialogProperties {
    public static TYPE_GET_GIFT: string = "getGift";
    public static TYPE_SENDMAIL: string = "sendMail";
    public title: string;
    public copy: string;
    public dialogType: string;

    constructor(title: string, copy: string, dialogType: string) {
        super();

        this.title = title;
        this.copy = copy;
        this.dialogType = dialogType;
    }
}
